
import { Component, Vue, Prop } from 'vue-property-decorator';
import { NotificationChannel, NotificationChannelType, NotificationSettingConfigGroup } from 'ah-api-gateways';

@Component
export default class NotificationGroupHeaderEditForm extends Vue {
  @Prop({ required: true }) group!: NotificationSettingConfigGroup;

  @Prop({ default: false }) showTitles!: boolean | string;

  @Prop({ default: false }) readonly!: string | boolean;

  @Prop({ default: false }) channels!: NotificationChannel[];

  get isTargettingEmail() {
    const channel = this.channels.find((n) => n.type === NotificationChannelType.EMAIL);
    return channel?.enabled;
  }

  get isTargettingInApp() {
    const channel = this.channels.find((n) => n.type === NotificationChannelType.IN_APP);
    return channel?.enabled;
  }

  get isTargettingSms() {
    const channel = this.channels.find((n) => n.type === NotificationChannelType.SMS);
    return channel?.enabled;
  }

  get NotificationChannelType() {
    return NotificationChannelType;
  }

  get titlesShown() {
    return this.showTitles !== false;
  }

  get allChildrenMandatory() {
    return (type: NotificationChannelType) => {
      let out = true;
      this.group.notifications.forEach((setting) => {
        if (setting.channels.find((channel) => channel.channelType === type)!.configurable) out = false;
      });
      return out;
    };
  }

  get calcStyles() {
    return (type: NotificationChannelType) => {
      let out: string[] = [];
      if (this.allChildrenMandatory(type)) {
        out.push('disabled');
        const channel = this.channels.find((n) => n.type === type);
        if (channel?.enabled) {
          out.push('disabled-on');
        } else if (channel) {
          out.push('disabled-off');
        }
      }
      return out;
    };
  }

  onTargetChange(type: NotificationChannelType, enabled: boolean) {
    this.$emit('update:change', { type: type, enabled: enabled });
  }
}
